import React, { useState } from "react";
import Modal from "common/Modal";

export function toBool(val) {
  var num = Number(val);
  if (isNaN(num)) {
    return val == "yes" ? true : false;
  } else {
    return val;
  }
}

export function fromBool(val) {
  var num = Number(val);
  if (typeof val === "boolean") {
    return val ? "yes" : "no";
  } else if (val == undefined) {
    return "no";
  } else {
    return val;
  }
}

export function toBlockOrNumber(val) {
  var num = Number(val);
  if (isNaN(num)) {
    return "block";
  } else {
    return (Number(val) / 1000).toFixed(3);
  }
}

export function checkPercentage(attr) {
  return attr.endsWith("%");
}

export const parsePolicies = (response) => {
  const [head, ...rows] = response.trim("\n").split("\n");
  const headAttrs = head.trim("\n").split(/\s+/);
  return rows.reduce((acc, row) => {
    const attrs = row.trim("\n").split(/\s+/);
    const policyName = attrs[0];
    const policyValues = attrs.reduce((accValues, attr, index) => {
      accValues[headAttrs[index].toLowerCase()] = attr;
      return accValues;
    }, {});
    acc[policyName] = policyValues;
    return acc;
  }, {});
};

export const getPolicies = (type) =>
  ifCl.run(`show policy ${type}`).then(parsePolicies);

export const BlockModal = ({ onClose, onApply }) => {
  const [open, setOpen] = useState(true);

  if (!open) {
    return null;
  }

  const handleApply = () => {
    onClose();
    onApply();
  };

  return (
    <Modal
      title="Are you sure ?"
      superIcon="warning"
      onClose={onClose}
      closeLabel="CANCEL"
      content={() => <>Traffic will be blocked when firing this policy</>}
      onApply={handleApply}
      applyLabel="OK"
    />
  );
};

export const parsePolicy = (response, responsePolicyMap) => {
  const lines = response.trim("\n").split("\n");
  const { policy } = lines.reduce(
    (acc, line) => {
      const [key, value] = line.split(":");
      if (/^\s/.test(key)) {
        const trimmedKey = key.trim("\n");
        const policyPropMapped =
          responsePolicyMap[`${acc.base}: ${trimmedKey}:`];
        if (policyPropMapped) {
          const policyPropName = policyPropMapped.name;
          const trimmedValue = value.trim("\n");
          const policyPropValue = policyPropMapped.valueF(trimmedValue);
          acc.policy[policyPropName] = policyPropValue;
        }
      } else {
        acc.base = key;
        const policyPropMapped = responsePolicyMap[`${key}:`];
        if (policyPropMapped) {
          const policyPropName = policyPropMapped.name;
          const trimmedValue = value.trim("\n");
          const policyPropValue = policyPropMapped.valueF(trimmedValue);
          acc.policy[policyPropName] = policyPropValue;
        }
      }
      return acc;
    },
    { base: "", policy: {} }
  );
  return policy;
};

export const getPolicy = (policy) => ifCl.run(`show policy ${safeStr(policy)}`);

export function setBrateValue(value) {
  if (value === SSHZERO_DFLT_VAL) {
    return "default";
  } else {
    return Math.floor(Number(value) * 1000).toString();
  }
}

export function setBdurValue(value) {
  if (value === SSHZERO_DFLT_VAL) {
    return "default";
  } else {
    return value;
  }
}

export function setBthrValue(value) {
  if (value === SSHZERO_DFLT_VAL) {
    return "default";
  } else {
    return Math.floor(Number(value) * 1000).toString();
  }
}

export function setBthrwValue(value) {
  if (value === SSHBTHRW_DFLT_VAL) {
    return "default";
  } else {
    return value;
  }
}

export const SSHRATE_DFLT_VAL = 100000;
export const SSHZERO_DFLT_VAL = 0;
export const SSHBTHRW_DFLT_VAL = 300;

const _localeSettings = [
  "en-US",
  {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  },
];

function expressAsDataSpeed(value) {
  return value > 999999
    ? `${Number(value / 1000000).toLocaleString(..._localeSettings)} Gbps`
    : value > 999
    ? `${Number(value / 1000).toLocaleString(..._localeSettings)} Mbps`
    : `${Number(value).toLocaleString(..._localeSettings)} Kbps`;
}

function inDataSpeedUnits(value) {
  return value === "no" || value === false
    ? "no"
    : expressAsDataSpeed(parseFloat(value));
}

function splitFieldAndValue(line) {
  return line.split(/\:\s/);
}

function wrapIntoIndentedSpan(text) {
  return `<span style="margin-left: 2ch;">${keepIndentation(text)}</span>`;
}

const NOT_ALLOWED_DYN_POLICY = ["Type", "DOS", "Dynamic update"];

const TIME_FIELDS_DYN_POLICY = [
  "Burst duration",
  "Burst threshold window",
  "Burst threshold duration",
  "Burst transition duration",
];

const SPEED_FIELDS_DYN_POLICY = [
  "Rate",
  "Burst rate",
  "Burst threshold",
  "Burst threshold",
];

function arrangeUnits([field, value]) {
  return TIME_FIELDS_DYN_POLICY.includes(field.trim(" "))
    ? [field, value + " s"]
    : SPEED_FIELDS_DYN_POLICY.includes(field.trim(" "))
    ? [field, inDataSpeedUnits(value)]
    : [field, value];
}

function onlyAllowed([field, _value]) {
  return NOT_ALLOWED_DYN_POLICY.includes(field) !== true;
}

function joinRecord([field, value]) {
  return `${field}: ${value}`;
}

function keepIndentation(fact) {
  return fact.startsWith("  ")
    ? wrapIntoIndentedSpan(fact.replace(/^\s\s/, ""))
    : fact;
}

function getPolicyIdLine(policyName) {
  return ifCl.run("show api policy " + safeStr(policyName)).then((response) => {
    const lines = response.trim("\n").split("\n");
    const idLine = lines.find((line) => line.indexOf("ID") !== -1);
    if (idLine) {
      return idLine;
    }
    return null;
  });
}

export function showDynPolicyRate(policyName, reducedOutput) {
  Promise.all([getPolicy(policyName), getPolicyIdLine(policyName)])
    .then(([responsePolicy, responseIdLine]) => {
      let lines = responsePolicy.trim("\n").split("\n");
      lines = lines.filter(
        (line) =>
          line.startsWith("Source:") === false &&
          (!reducedOutput ||
            (reducedOutput &&
              line.search(/Burst|Blocking|Auto-Congestion-Management/) === -1))
      );
      if (responseIdLine) {
        lines.splice(1, 0, responseIdLine);
      }

      const text = `<p style="line-height: 20px !important; margin-left: 12px">
        ${lines
          .map(splitFieldAndValue)
          .filter(onlyAllowed)
          .map(arrangeUnits)
          .map(joinRecord)
          .map(keepIndentation)
          .join("<br>")}
        </p>`;

      showModalGeneric("hide", "Policy Details", text, true);
    })
    .catch((error) => console.error(error));
}
